<div class="bg-surface-100 dark:bg-surface-950 px-8 lg:px-12 xl:px-20 py-20">
	<div class="flex flex-col-reverse lg:flex-row gap-8 md:gap-20 justify-center items-center">
		<div
			class="flex-1 flex flex-col gap-4"
			pAnimateOnScroll
			enterClass="animate-enter fade-in-10 slide-in-from-l-8 animate-duration-1000"
			leaveClass="animate-leave fade-out-0">
			<app-headline-large [title]="content.title"></app-headline-large>
			<app-body-large [description]="content.description"></app-body-large>
			@if (content.link){
				<app-link
					class="mt-4"
					[type]="content.link.type"
					[label]="content.link.title"
					bgColor="light"
					(clicked)="ctaButtonClicked(content.link.path)"></app-link>
			}
		</div>
		<div
			class="flex-1"
			pAnimateOnScroll
			enterClass="animate-enter fade-in-10 slide-in-from-r-8 animate-duration-1000"
			leaveClass="animate-leave fade-out-0">
			@if (content.image){
			<img
				loading="lazy"
				[src]="content.image.src"
				[alt]="content.image.alt"
				class="w-full object-cover dark:brightness-[0.76] dark:hue-rotate-35 dark:saturate-[1.8] dark:contrast-[1.4] shadow-md border-10 border-white" />
			}
		</div>
	</div>
</div>
